/** @file Rewrites the deform offsets of one mesh through per-vertex linear maps (binding changes). */
import type { Draft } from 'immer';
import type { Doc, Id } from '@pose2d/format/types';
import { transformMeshPoints } from './transformMeshPoints';

/** Every key of `deform[id]` in every animation: offset pair k (vertex start/2 + k) through Lin(mats[vertex]); null stays null. */
export function transformDeformKeys(draft: Draft<Doc>, id: Id, mats: Float64Array): void {
  for (const anim of Object.values(draft.animations)) {
    for (const key of anim.deform[id] ?? []) {
      if (key.offsets) key.offsets.values = transformMeshPoints(key.offsets.values, mats, key.offsets.start / 2, true);
    }
  }
}
